<!--
하우스 센터이동 컴포넌트
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">
            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons">flip_to_back</i>
                    주문서 센터이동 >
                    <span v-if="stepIn('step-input')">정보입력</span>
                    <span v-if="stepIn('step-confirm')">최종확인</span>
                    <span v-if="stepIn('step-done')">완료</span>
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-small" v-if="stepIn(['step-input', 'step-confirm'])">

                <!-- 하우스정보 -->
                <div class="">
                    <i class="material-icons">mail</i>
                    <b>수취인정보</b>
                </div>
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 9rem">
                        <col>
                        <col style="width: 9rem">
                        <col>
                    </colgroup>

                    <tr>
                        <th>
                            수취인
                        </th>
                        <td>
                            {{ house.name }}
                        </td>
                        <th>
                            배송코드
                        </th>
                        <td>
                            {{ house.code }}
                        </td>
                    </tr>
                    <tr>
                        <th>

                            우편번호
                        </th>
                        <td>
                            {{ house.zipcode }}
                        </td>
                        <th>

                            합배송코드
                        </th>
                        <td>
                            {{ house.sp_code }}
                        </td>
                    </tr>

                    <tr>
                        <th>

                            주소
                        </th>
                        <td colspan="3">
                            {{ house.addr1 }}
                            {{ house.addr2 }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            핸드폰 / 전화번호
                        </th>
                        <td>
                            {{ house.cell }}
                            <span v-if="house.tel">/ {{ house.tel }}</span>
                        </td>

                        <th>
                            운송장
                        </th>
                        <td>
                            {{ house.blno }}
                            <div class="uk-text-meta" v-if="house.sub_blnos">
                                {{ house.sub_blnos }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            배송메모
                        </th>
                        <td>
                            {{ house.sp_memo }}
                        </td>

                        <th>

                            통관정보
                        </th>
                        <td>
                            {{ house.customs_clearance_no }}
                            {{ house.customs_reg_no }}
                            {{ house.customs_biz_no }}
                            {{ house.customs_foreign_no }}
                            {{ house.customs_passport_no }}
                            {{ house.customs_nation }}

                        </td>
                    </tr>


                </table>

                <!-- 상품정보 -->
                <div class="uk-margin-small-top">
                    <i class="material-icons">list</i>
                    <b>상품정보({{ houseProds.length }})</b>
                </div>
                <div class="prod-list">
                    <table class="info-table small uk-width-1-1">
                        <colgroup>
                            <col style="width: 7rem">
                            <col style="width: 15rem">
                            <col style="width: 4rem">
                            <col>

                        </colgroup>

                        <thead>
                        <tr>
                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-left">
                                배송단계/등록일/해외오더/트래킹
                            </th>

                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-left">
                                상품정보
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(prod) in houseProds"
                            :key="prod.id"
                        >
                            <td scope="col" class="uk-text-center">
                                {{ prod.id }}
                                <a class="detail-link" :href="'/prods/' + prod.id" target="_blank" title="상세페이지 새창으로 열기">
                                    <i class="material-icons">open_in_new</i>
                                </a>
                            </td>
                            <td scope="col" class="uk-text-left">
                                <div class="uk-flex">
                                    <div class="uk-margin-small-right" title="배송단계"><i class="material-icons md-18">label</i>{{ prod.state_text}}</div>
                                    <div class="uk-margin-small-right" title="등록일"><i class="material-icons md-18">calendar_month</i>{{ dateYmd(prod.created_at) }}</div>
                                </div>
                                <div class="" title="해외오더"><i class="material-icons md-18">receipt</i>{{ prod.buy_order_code}}</div>
                                <div class="" title="트래킹"><i class="material-icons md-18">local_shipping</i>{{ prod.tracking_no}}</div>
                            </td>

                            <td scope="col" class="uk-text-center">
                                {{ prod.amount}}
                            </td>
                            <td scope="col" class="uk-text-left">
                                <div class="uk-flex uk-flex-left uk-flex-middle">
                                    <img class="prod-img" :src="prod.img_url"/>

                                    <div class="uk-width-expand uk-flex uk-flex-wrap">
                                        <div class="uk-margin-small-right" title="쇼핑몰" v-if="prod.vender_mall"><i class="material-icons md-18">info</i>{{ prod.vender_mall}}</div>
                                        <div class="uk-margin-small-right" title="브랜드" v-if="prod.brand"><i class="material-icons md-18">info</i>{{ prod.brand}}</div>
                                        <div class="uk-width-1-1" title="상품명" v-if="prod.name"><i class="material-icons md-18">title</i>{{ prod.name}}</div>
                                        <div class="uk-margin-small-right" title="색상" v-if="prod.color"><i class="material-icons md-18">info</i>{{ prod.color}}</div>
                                        <div class="uk-margin-small-right" title="사이즈" v-if="prod.size"><i class="material-icons md-18">info</i>{{ prod.size}}</div>
                                    </div>
                                </div>




                            </td>
                        </tr>
                        </tbody>

                    </table>
                </div>

                <div class="uk-flex uk-flex-between">
                    <!-- 센터 선택 -->
                    <div class="uk-margin-small-top uk-flex-1" v-if="origRegion">
                        <i class="material-icons">place</i>
                        <b>현재 센터</b>
                        <div class="uk-margin-left uk-margin-small-bottom">
                            <img :src="origRegion.flag16" />
                            {{ origRegion.name }}
                        </div>

                        <i class="material-icons">radio_button_checked</i>
                        <b>이동할 센터를 선택하세요</b>
                        <div class="uk-margin-left">
                            <app-input-radio
                                v-model="inputs.to_region_id"
                                :options="toRegionIdOptions"
                            >
                                <template
                                    slot="optionText"
                                    slot-scope="{ option }"
                                >
                                    <img :src="option.flag16" />
                                    <span class="">{{ option.text }}</span>

                                </template>
                            </app-input-radio>
                        </div>
                    </div>

                    <!-- 사유 -->
                    <div class="uk-margin-small-top uk-flex-1">
                        <i class="material-icons">description</i>
                        <b>센터이동 사유</b>
                        <div class="uk-margin-small-left">

                            <app-input-textarea
                                class="uk-margin-bottom"
                                placeholder="사유를 작성하세요"
                                :textarea-rows="5"
                                v-model.trim="inputs.reason"
                            ></app-input-textarea>
                        </div>
                    </div>

                </div>


            </div>

            <div class="uk-modal-footer uk-text-right">
                <!-- 주의사항 -->
                <div class="warnings">
                    <div class="title">
                        센터이동시 아래 내용을 주의하세요.
                    </div>
                    <div class="item">* 운송장번호가 새로 발급됩니다.</div>
                    <div class="item">* 구입단가, 단가는 해당 국가의 화폐단위로 변경됩니다.</div>

                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    @click="submitConfirm()"
                >
                    <span uk-icon="icon: check"></span>
                    센터이동
                </button>
            </div>

            <!-- 컨펌화면 레이아웃 -->
            <div class="confirm-overlay"  v-if="stepIn('step-confirm')">
                <div class="confirm-dialog">


                    <div class="uk-text-center uk-text-large uk-margin-top">
                        정말 센터이동 하겠습니까?
                    </div>
                    <div class="uk-margin-top uk-flex uk-flex-center">
                        <div class="uk-margin-right uk-text-large" v-if="origRegion">
                            <img :src="origRegion.flag32" />
                            {{ origRegion.name }}
                        </div>
                        <div class="uk-margin-right uk-text-primary">
                            <i class="material-icons md-36">navigate_next</i><i class="material-icons md-36">navigate_next</i><i class="material-icons md-36">navigate_next</i>
                        </div>
                        <div class="uk-margin-right uk-text-large" v-if="toRegion">
                            <img :src="toRegion.flag32" />
                            {{ toRegion.name }}
                        </div>
                    </div>
                    <div class="uk-text-center uk-margin-bottom uk-margin-large-top">
                        <button
                            type="button"
                            class="uk-button uk-button-black uk-margin-right"
                            @click="submit()"
                        >
                            <span uk-icon="icon: check"></span>
                            예, 센터이동 하겠습니다.(완료)
                        </button>

                        <button
                            type="button"
                            class="uk-button uk-button-default"
                            @click="changeStep('step-input')"
                        >
                            <span uk-icon="icon: close"></span> 아니오
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import moment from "moment";
    import stepAble from "../common/step-able.vue";
    import regionAble from "../common/region-able.vue";
    export default {
        mixins: [
            regionAble,
            stepAble,
        ],
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (string) 현재 진행단계
                currStep: 'step-input',

                // (array) 진행단계 코드 배열
                steps: [
                    'step-input',
                    'step-confirm',
                    //'step-done',
                ],

                // (object) 하우스정보
                house: {},

                // (array) 하우스 상품배열
                houseProds: [],

                // (array) 이동할 센터 options
                toRegionIdOptions: [],

                /**
                 * 입력값
                 */
                inputs: {},
            };
        },
        mounted: function () {
            //console.log('mounted in component');
        },
        computed: {
            /**
             * 원본 지역
             * @returns {Region}
             */
            origRegion() {
                return this.get_region(this.house.region_id);
            },
            /**
             * 대상 지역
             * @returns {Region}
             */
            toRegion() {
                if (! this.inputs.to_region_id) {
                    return null;
                }
                return this.get_region(this.inputs.to_region_id);
            },
        },
        methods: {
            /**
             * 날짜 변환
             * - 입력 : '2024-04-11 12:33:17'
             * - 출력 : '2024-04-11'
             * @param date_string
             * @return string
             */
            dateYmd(date_string) {
                if (! date_string) {
                    return null;
                }
                return moment(date_string).format('YYYY-MM-DD');
            },

            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param house_id 하우스ID
             */
            form(house_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                    to_region_id: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/houses/' + house_id + '?with_owner_usable_agents',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.house = response.house;
                    this.houseProds = response.house_prods;

                    // regionId 옵션작성
                    this.toRegionIdOptions = [];
                    _.each(response.owner_usable_agents, (role) => {
                        let region = this.get_region(role.region_id);
                        if (this.origRegion.id === region.id) {
                            return;
                        }
                        this.toRegionIdOptions.push({
                            text: region.name,
                            val: region.id,

                            flag16: region.flag16,
                        });
                    });

                    //console.log(response);
                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * 서브밋 전 최종컨펌처리
             * @return Promise
             */
            submitConfirm() {
                // 입력값 검증
                if(! this.inputs.to_region_id) {
                    alert('이동할 센터를 선택하세요.');
                    return;
                }
                if(! this.inputs.reason) {
                    alert('사유는 반드시 입력해야 합니다.');
                    return;
                }

                // 컨펌단계 이동
                this.changeStep('step-confirm');
            },

            /**
             * submit
             */
            submit() {
                // 전송
                let submited = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.house.id + '/change-center/' + this.inputs.to_region_id,
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });
                submited.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.refresh();
                    });
                });



            },
        },
    }
</script>

<style lang="scss" scoped>
    .warnings {
        margin: 10px 0;
        .title {
            font-weight: bold;
            color: #000;
            margin-bottom: 5px;
        }
        .item {
            color: #000;

        }
    }

    // 테이블
    .info-table {
        th {
            background-color: #fafafa;
        }
        th, td {
            font-size: 0.875rem !important;
        }

        .material-icons {
            color: #666;
            margin-right: 0.25rem;
        }

        img.prod-img {
            width: 3rem;
            max-height: 3rem;
            margin-right: 0.5rem;
        }

        // 상품상세 링크
        a.detail-link {
            .material-icons {
                color: #1e87f0;
                margin: 0;
            }
        }
    }

    // 상품영역
    .prod-list {
        overflow: auto;
        max-height: 12rem;
    }

    // 컨펌화면
    .confirm-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .confirm-dialog {
            width: 90%;
            padding: 1rem;
            background-color: #fff;

        }
    }

</style>